import * as React from "react";

import { Theme, useMediaQuery } from "@material-ui/core";
import throttle from "just-throttle";

export function useHidingHeader(): boolean {
  const [isHeaderVisible, setIsHeaderVisible] = React.useState(true);
  const prevScrollPosition = React.useRef<number | null>(null);
  const isMobileView = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  React.useEffect(() => {
    const handleScroll = () => {
      const currentScrollPosition = window.scrollY;
      const previousScrollValue = prevScrollPosition.current;
      if (typeof previousScrollValue !== "number") {
        prevScrollPosition.current = currentScrollPosition;
        return;
      }
      const direction =
        currentScrollPosition > previousScrollValue ? "down" : "up";
      if (direction === "down") {
        setIsHeaderVisible(false);
      } else if (direction === "up") {
        setIsHeaderVisible(true);
      }

      prevScrollPosition.current = currentScrollPosition;
    };
    window.addEventListener("scroll", throttle(handleScroll, 100));
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return isMobileView ? isHeaderVisible : true;
}
